import React from 'react'
import logolion from '../Assets/logo.ico'
import { NavLink } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { auth } from "../Config/firebase";
import {
  createUserWithEmailAndPassword,
  signOut,
  sendEmailVerification,
  signInWithEmailAndPassword,
  sendPasswordResetEmail
} from "firebase/auth";

const Login = () => {
  const {register,handleSubmit,formState: { errors }}=useForm();//hookforms
  const navigate=useNavigate();

  // const Login=()=>{
  //   navigate('/home')
  // }

  // const signIn = async (event) => {
  //   // event.preventDefault(); // Prevent default form submission behavior

  //   try {
  //     const email = localStorage.getItem("email");
  //     const password = localStorage.getItem("password");

  //     // Perform Firebase authentication
  //     await signInWithEmailAndPassword(auth, email, password);

  //     // If successful, redirect to home page
  //     navigate("/home");
  //   } catch (error) {
  //     // Handle errors appropriately, e.g., display error message
  //     alert("Invalid email or password. Please try again.");
  //     console.error("Login error:", error.message);
  //   }
  // };

  const signIn = async (data) => {
    console.log('data',data);
    try {
      await signInWithEmailAndPassword(auth, data.email, data.password);
      navigate("/home");
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <div className='Login'>
        <div className='LoginBanner'>
            <div className='logoHolder'>
                <img src={logolion} style={{width:'70px'}}/>
                <h1 style={{color:'white', fontFamily:'cursive'}}>Canvas</h1>
            </div>
            {/* <img className='LoginBanner' src={paint} /> */}
        </div>
        <form onSubmit={handleSubmit(signIn)} className='inputHolder'>
            <h2 className='LoginHead'>Sign In</h2>
            <hr/>
            <div className='inputs'>
            <p className='inputLabel'>Email</p>
            <input type='text' className={errors.email ? 'input-error' : 'input'} placeholder='email address' {...register(
              "email",
              {
                required:true,
                maxLength:30,
                pattern: {
                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                message: 'Invalid email address'
              }
              })}/>
            {errors?.email?.type === "required" && <p className='errorMsg'>Please provide username</p>}
            {errors.email && <p className='errorMsg'>{errors.email.message}</p>}


            <p className='inputLabel'>Password</p>
            <input type='password' className={errors.password?'input-error':'input'} placeholder='password' {...register(
              "password",
              {
                required:true,
                minLength: {
                value: 6,
                message: 'Password must be at least 6 characters long'
              }
              })} />
            {errors?.password?.type === "required" && <p className='errorMsg'>Please provide password</p>}
            {errors.password && <p className='errorMsg'>{errors.password.message}</p>}
            
            <button className='loginBtn'>Login</button>

            </div>
            <div>
                <p>New to Canvas?
                    <NavLink to='/register'>Register</NavLink>
                </p>
            </div>
        </form>
    </div>
  )
}

export default Login